export const getClosestNumber = (arr: number[], target: number): number | null => {
    if (arr.length === 0) return null;

    return arr.reduce((closest, current) =>
        Math.abs(current - target) < Math.abs(closest - target) ? current : closest
    );
};